module.exports = __webpack_public_path__ + "img/G4.ef025d5c.png";